
export default class Matomo {
    constructor() {
        this.paq = window._paq || [];
    }

    modalOpened() {
        this.paq.push(['trackEvent', 'Google-Fonts-Scanner', '90 Modal geöffnet']);
    }

    modalCancelled() {
        this.paq.push(['trackEvent', "Google-Fonts-Scanner", "100 Modal abgebrochen", ""]);
    }

    formSent() {
        this.paq.push(['trackEvent', "Google-Fonts-Scanner", "93 E-Mail-Formular gesendet", ""]);
    }

    doiCompleted() {
        this.paq.push(['trackEvent', "Google-Fonts-Scanner", "96 DOI erfolgreich", ""]);
    }
}


